module.exports = __webpack_public_path__ + "static/media/shape.d4235c56.png";